import { StockConstant } from '../constants';
import { RequestAction } from '.';

export const getStocks = params =>
  RequestAction.request(StockConstant.GET_STOCKS, {
    params,
    url: '/api/stock',
  }, false);

export const setStocks = payload => ({
  payload,
  type: StockConstant.SET_STOCKS,
});
